import i18next from '../../../i18n';
export const translate = (key, params) => {
    if (params)
        return i18next.t(key, { ...params, framework: 'React' });
    else
        return i18next.t(key, { framework: 'React' });
};
